@if (isInitializing()) {
  <app-loader></app-loader>
} @else {
  <router-outlet></router-outlet>
}

<!-- Global Confirm Dialog -->
<app-global-confirm-dialog></app-global-confirm-dialog>

<!-- Global Prompt Dialog -->
<app-global-prompt-dialog></app-global-prompt-dialog>

<!-- Progress Indicator -->
<app-progress-indicator></app-progress-indicator>

<!-- PWA Update Notification -->
<app-pwa-update-notification></app-pwa-update-notification>
